module.exports = __webpack_public_path__ + "static/media/page04_bg.b0153c2d.png";